import React, { Component, useEffect, useState } from 'react';
import { Button, Checkbox, Space, Tag } from 'antd';
import { useGetAllCSVFields, useGetSelectedCSVFields, useUpdateCSVFields } from '../../hooks/usePlanning';
import stl from 'string-to-color';

export default function ManageFields({ companyCode }) {
    const { data: allCsvData } = useGetAllCSVFields(companyCode);
    const { data: selectedCSVData, refetch: refetchSelectedCSVData } = useGetSelectedCSVFields(companyCode);

    const UpdateCSVFieldsMutation = useUpdateCSVFields();

    const [selectedFields, setSelectedFields] = useState([]);
    const [isModified, setIsModified] = useState(false);

    useEffect(() => {
        setSelectedFields(selectedCSVData);
        setIsModified(false);
    }, [selectedCSVData]);

    const HandleCheckChange = (checked, key, path) => {
        const temp = { ...selectedFields };
        const index = temp?.data?.findIndex(d => d.key == key && d.path == path);
        if (!!checked) {
            temp.data.push({
                key,
                path,
            });
        } else {
            if (index > -1) {
                temp.data.splice(index, 1);
            }
        }
        setSelectedFields(temp);
        setIsModified(true);
    };

    const HandleUpdateFields = () => {
        UpdateCSVFieldsMutation.mutateAsync([companyCode, selectedFields?.data])
            .then(result => {})
            .catch(error => {})
            .finally(() => {
                refetchSelectedCSVData();
                setIsModified(false);
            });
    };

    return (
        <>
            <h2>Manage Fields</h2>
            <hr />
            <br />
            <div
                style={{
                    width: '100%',
                    height: '70vh',
                    display: 'flex',
                    flexDirection: 'column',
                    flexWrap: 'wrap',
                    padding: '10px 0',
                    overflow: 'auto',
                }}
            >
                {allCsvData?.data?.map(({ key, path }) => {
                    return (
                        <div
                            key={`${key} (${path})`}
                            style={{
                                height: '25px',
                            }}
                        >
                            <Checkbox
                                checked={selectedFields?.data?.findIndex(d => d.key == key && d.path == path) > -1}
                                onClick={e => HandleCheckChange(e.target.checked, key, path)}
                            >
                                <Tag color={stl(path)}>{path}</Tag>
                                {`${key}`}
                            </Checkbox>
                        </div>
                    );
                })}
            </div>
            <hr />
            <Space
                style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    padding: '0 10px',
                    marginTop: '10px',
                }}
            >
                <Button type="primary" onClick={() => HandleUpdateFields()} disabled={!isModified}>
                    Save
                </Button>
                <Button disabled={!isModified} onClick={() => refetchSelectedCSVData()}>
                    Cancel
                </Button>
            </Space>
        </>
    );
}
